"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nakedEvent = exports.sendEvent = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = _interopRequireDefault(require("../utils/logger"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var sendEvent = function sendEvent(client, params) {
  var sendPromise;

  if (!params.eventVersion) {
    if (params.version) {
      params.eventVersion = params.version;
    } else {
      _logger["default"].error(new Error('Either version or eventVersion argument must be passed to sendEvent'));
    }
  }

  var eventSpecs = _objectSpread(_objectSpread({}, params), {}, {
    eventTime: new Date()
  });

  if (client.eventGate.shouldAllowSends()) {
    // The app already initialized RSW. We can create events synchronously:
    // Queue event for sending
    var structuredData = client.structureData(eventSpecs);
    sendPromise = client.batcher.queueEvent(structuredData, eventSpecs.options || {});
  } else {
    sendPromise = client.eventGate.pushPreloadEvent(eventSpecs);
  }

  return sendPromise;
}; // Generic types added here just to not break backwards-compatibility
// Should remove when CES support is dropped


exports.sendEvent = sendEvent;

// Note that we have *not* made this function an async. This is because
// the function must be sync up until `structureData` is called
var nakedEvent = function nakedEvent(client, legacyEventSpecs) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    force: false
  };
  var sendPromise;
  var eventSpecs = {
    data: legacyEventSpecs.data,
    type: legacyEventSpecs.type,
    eventVersion: legacyEventSpecs.meta.version,
    eventTime: legacyEventSpecs.meta.eventTime,
    options: options
  };

  if (client.eventGate.shouldAllowSends()) {
    // The app already initialized RSW. We can create events synchronously:
    // Queue event for sending
    var structuredData = client.structureData(eventSpecs);
    sendPromise = client.batcher.queueEvent(structuredData, options);
  } else {
    sendPromise = client.eventGate.pushPreloadEvent(eventSpecs);
  }

  return sendPromise;
};

exports.nakedEvent = nakedEvent;